import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Resolve, RouterStateSnapshot } from '@angular/router';
import { WIZ_COMMAND_STATE } from '@wizeoo/akm-core-lib';
import {
  IWizRoute,
  WizCommand,
  WizNavigationManager,
  WizRoot,
  WizEventManager,
  WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent, ReloadCmd } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { BusinessUnitVO } from '@wizeoo/akm-common-lib';
import { DomainVO } from '@wizeoo/akm-common-lib';
import { FallbackViewState } from './../../views/fallback/fallback.view';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { RouteEngine } from './route.engine';

@Injectable({ providedIn: 'root' })
export class ContextGuard implements CanActivate, Resolve<any> {
  constructor() {}

  /**
   * réponse de contexte sur tentative d'accès à une vue
   * Va charger le contexte si nécessaire
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if(!Model.getInstance().connectedUser) {
      // console.log('contextGard no User', route['_routerState'].url);
      return false;
    }

    const askedDomain: string = Model.getInstance().domainCode;
    const askedBu: string = Model.getInstance().businessUnitCode;
    const domains: DomainVO[] = Model.getInstance().connectedUser.allDomains; // tous les domains du user
    
    // console.log('contextGard no User', route['_routerState'].url); 
    const url: URL = new URL(window.location.origin + route['_routerState'].url);
    const askedVision: string = url?.searchParams.get('vision');

    let realDomain: DomainVO = null;
    domains.forEach((d: DomainVO) => { // on vérifie que le domaine demandé existe
      if(d.code === Model.getInstance().domainCode) {
        realDomain = d;
      }
    });
    
    // la bu existe réellement ?
    let realBu: BusinessUnitVO = Model.getInstance().businessUnitEngine.realBusinessUnit;


    const vis = Model.getInstance().visionEngine.getCurrentDomainVisions(); //  Model.getInstance().visionsDic;
    let realVision: VisionVO = null;
    if(vis.length === 1) {
      realVision = vis[0];
    } else {
      vis.forEach((v: VisionVO) => { // la vision demandée
        if(v.code === askedVision && v.businessUnitCode === askedBu) {
          realVision = v;
        }
      });
    }

    if(!!realVision) {
      Model.getInstance().domainCode = realVision.domain;
      Model.getInstance().businessUnitCode = realVision.businessUnitCode;
      Model.getInstance().visionEngine.selectVision(realVision.code);
      // console.log('gotMy vision', realVision);
    }
    
    // pas de domain ou de BU, retour sur la fallback
    if (!realDomain || !realBu) {
      // console.log('contextGard bad dom or bu', route['_routerState'].url, realDomain, realBu);
      const wizroute: IWizRoute = route.routeConfig as IWizRoute;
      WizNavigationManager.navigateWithState<FallbackViewState>(RouteEngine.FALLBACK_VIEW, { redirectFrom:route['_routerState'].url,  redirectTo: wizroute.fullPath});
      return false;
    }

    // if (uniqueVision) {
    //   console.log('im unique', 'whats next');
    // }

    return true;
  }

  /** traitement à jouer sur une entrée de vue */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    return new Promise((resolve, reject) => {
      // console.log('contextGard bad dom or bu', route['_routerState'].url);
      const vision: VisionVO = Model.getInstance().currentVision;
      const calls = [];

      // On récupére l'information contextFree à partir de la route et on la transmet au NavigationEngine 
      // pour déterminer la sélection de l'onglet à appliquer
      Model.getInstance().tabEngine.selectTabFromContext = !route.firstChild.data?.contextFree;

      // la commande...
      const gpCmd: ReloadCmd = new ReloadCmd(Model.getInstance()).prepareCalls(vision, (cmd: ReloadCmd) => {
        if (cmd.state === WIZ_COMMAND_STATE.SUCCESS) {
          // retour de chargement user, on charge la trad ansi que les données de base
          Model.getInstance().localeEngine.feedLanguages();
          WizTranslationManager.getInstance().loadCumulatedTranslations([
            Model.getInstance().currentLocaleCode,
            Model.getInstance().buLocaleCode,
          ]);
          Model.getInstance().navigationEngine.updateUrlContext();
          resolve('resolved');


          WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SELECT_VISION, Model.getInstance().currentVision)); // sinon pas menu / info sur init
        } else {
          let errorMsg = 'unknown';
          cmd.commandPile.forEach((sub: WizCommand<any>) => {
            if(sub.result === WIZ_COMMAND_STATE.FAULT) {
              errorMsg = sub.error.message;
            }
            // console.log('contextGard resolve, fault', route['_routerState'].url, cmd);
            reject(errorMsg);
          });
        }
      }); // fin reload


      if(gpCmd.calls.length > 0) {
        gpCmd.execute();
      } else { // tout est déjà ok 
        // console.log('contextGard all ok');
        resolve('resolved');
      }
    });
  }
}
